import React, { ReactNode } from "react";

interface MenuItemProps {
  icon: ReactNode;
  label: string;
  onClick: () => void;
}

const MenuItem: React.FC<MenuItemProps> = ({ icon, label, onClick }) => (
  <button onClick={onClick} className="menuBtn">
    {icon}
    {label}
  </button>
);

export default MenuItem;
